const supplementary = r => require.ensure([], () => r(require('@/page/supplementary/supplementary')), 'supplementary');
const supplementaryEnableList = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryEnableList/supplementaryEnableList')), 'supplementaryEnableList');
const supplementaryExamineList = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryExamineList/supplementaryExamineList')), 'supplementaryExamineList');
const supplementaryExamineDetails = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryExamineDetails/supplementaryExamineDetails')), 'supplementaryExamineDetails');
const supplementaryCommitteeList = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryCommitteeList/supplementaryCommitteeList')), 'supplementaryCommitteeList');
const supplementaryCommitteeDetails = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryCommitteeDetails/supplementaryCommitteeDetails')), 'supplementaryCommitteeDetails');
const supplementaryEaAreaList = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryEaAreaList/supplementaryEaAreaList')), 'supplementaryEaAreaList');
const supplementaryEaAreaDetails = r => require.ensure([], () => r(require('@/page/supplementary/supplementaryEaAreaDetails/supplementaryEaAreaDetails')), 'supplementaryEaAreaDetails');

const supplementaryRouter = {
    path: '',
    component: supplementary,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive:true
    },
    name: '物业备案数据补录',
    redirect: '/supplementary',
    children: [
        {
            path: '/supplementaryEnableList',
            component: supplementaryEnableList,
            name: '数据补录',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true
            },
        },
        {
            path: '/supplementaryExamineList',
            component: supplementaryExamineList,
            name: '审核列表',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true
            },
        },
        {
            path: '/supplementaryExamineDetails',
            component: supplementaryExamineDetails,
            name: '合同审核',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: false
            },
        },
        {
            path: '/supplementaryCommitteeList',
            component: supplementaryCommitteeList,
            name: '业委会列表',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true
            },
        },
        {
            path: '/supplementaryCommitteeDetails',
            component: supplementaryCommitteeDetails,
            name: '业委会信息列表',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: false
            },
        },
        {
            path: '/supplementaryEaAreaList',
            component: supplementaryEaAreaList,
            name: '物业区域数据补录列表',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true
            },
        },
        {
            path: '/supplementaryEaAreaDetails',
            component: supplementaryEaAreaDetails,
            name: '物业区域数据补录',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true
            },
        },
    ]
};

export default supplementaryRouter;
